import { createIcon } from '@chakra-ui/icons';

export const Columns = createIcon({
  displayName: 'Columns',
  viewBox: '0 0 24 22',
  d: 'M21.5871 0H2.41291C1.08219 0 0 1.08219 0 2.41291V19.3033C0 20.634 1.08219 21.7162 2.41291 21.7162H21.5871C22.9178 21.7162 24 20.634 24 19.3033V2.4117C23.9987 1.77226 23.7441 1.1594 23.2918 0.707355C22.8395 0.255315 22.2265 0.000956452 21.5871 0ZM7.23873 19.3033H2.41291V6.03107H7.23873V19.3033ZM14.4775 19.3033H9.65164V6.03107H14.4775V19.3033ZM16.8904 19.3033V6.03107H21.5871L21.5883 19.3033H16.8904Z',
});
